































































import mixins from 'vue-typed-mixins';
import UserUtils, { User } from '@/utils/UserUtils';
import cloneDeep from 'lodash.clonedeep';
import deepEqual from 'deep-equal';
import { Location } from 'vue-router';
import ResetPassword from './ResetPassword.vue';
import UserSendEmail from './UserSendEmail.vue';
export default mixins().extend({
  components: {
    ResetPassword,
    UserSendEmail,
  },

  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },

    tabs(): any {
      return [
        {
          text: this.$i18n.tc('app.label.detail', 2),
          location: { name: 'user-edit-details' },
        },
        {
          text: this.$i18n.tc('model.user.permission', 2),
          location: { name: 'user-edit-permissions' },
        },
      ];
    },

    tab(): undefined | number {
      return this.tabs?.findIndex(
        (tab: any) => this.$route.name === tab.location.name
      );
    },
  },

  data(): {
    pristine?: Partial<User>;
    user?: Partial<User>;
  } {
    return {
      pristine: undefined,
      user: undefined,
    };
  },

  async mounted() {
    this.$loading(true);
    try {
      if (this.id) {
        const resp = await Promise.all([UserUtils.api.get(this.id)]);
        this.pristine = resp[0];
        this.user = cloneDeep(this.pristine);
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
    this.$loading(false);
  },

  methods: {
    async navigate(location: Location) {
      if (
        typeof location === 'string'
          ? this.$route.path !== location
          : this.$route.name !== location.name
      ) {
        let allowNavigation = !deepEqual(this.user, this.pristine)
          ? await this.$confirm(
              this.$i18n.t('validation.confirmation.navigation').toString()
            )
          : true;

        if (allowNavigation) {
          await this.$router.push(location);
          this.user = cloneDeep(this.pristine);
        }
      }
    },

    async submit() {
      if (this.user) {
        if (!this.user.password) {
          delete this.user.password; // if the password is empty string, delete it from JSON
        }
        try {
          this.$alert.hide('submit');
          await UserUtils.api.update(this.user);
          this.pristine = cloneDeep(this.user);

          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.$languageobj('model.user.label')],
            }),
          });
        } catch (error) {
          this.$alert.show('submit', {
            type: 'error',
            messages: this.$handleAPIError(error, this.$refs.observer),
          });
        }
      }
    },

    async remove() {
      await this.$confirm(
        this.$i18n
          .t('validation.confirmation.delete', [this.pristine?.username])
          .toString(),
        async () => {
          if (this.pristine?.id) {
            try {
              this.$alert.hide('remove');

              await UserUtils.api.remove(this.pristine.id);
              await this.$router.push({ name: 'user-list' });

              this.$toast.push({
                type: 'success',
                text: this.$languageobj('validation.success.delete', {
                  values: [this.pristine?.username],
                }),
              });
            } catch (error) {
              this.$alert.show('remove', {
                type: 'error',
                messages: this.$handleAPIError(error),
              });
            }
          }
        }
      );
    },
  },
});
